<script setup lang="ts">
  import SelectQC from '@qicgroupdoha/qic-connect-ds/components/SelectQC'
  import { useI18n } from 'vue-i18n'

  interface Props {
    modelValue: string | null
    relations: Array<{ code: string; desc: string }>
    errors?: string[]
    isValid: boolean
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<template>
  <!-- @vue-ignore -->
  <SelectQC
    :model-value="modelValue"
    :options="relations"
    :label="$t('qlm_relationship')"
    :is-valid="isValid"
    :errors="errors"
    title-key="desc"
    value-key="code"
    name="relationship"
    is-filterable
    data-test="relationship-select"
    :locale="locale"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
